// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".points_list{width:100%}.points_list .points-em{position:relative;left:3em}.points_list .el-input--mini{width:48px;margin:0 10px}.points_list .points_list_input{margin-left:64%}.el-icon-del.list-del{margin-top:0;right:80px!important;height:30px;line-height:30px;cursor:pointer;position:unset}.el-collapse{border-bottom:none}", ""]);
// Exports
module.exports = exports;
